import { useAsync } from 'react-use'
import { integrationsApi } from '@/api'
import type { IntegrationItem } from '@/api/integrations/integrations.types'
import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'
import { filterMaxCrmIntegrations } from '@pages/Admin/CRMSettings/tabs/GeneralPage/components/MaxCrmBotsSettings/lib/maxCrmIntegration.helpers'
import { filterTgCrmIntegrations } from '@pages/Admin/CRMSettings/tabs/GeneralPage/components/TgCrmBotsSettings/lib/tgCrmIntegration.helpers'
import { filterVkCrmIntegrations } from '@pages/Admin/CRMSettings/tabs/GeneralPage/components/VkCrmCommunitiesSettings/lib/vkCrmIntegration.helpers'
import { filterWazzupCrmIntegrations } from '@pages/Admin/CRMSettings/tabs/GeneralPage/components/WazzupCrmSettings/lib/wazzupCrmIntegration.helpers'

const CRM_INTEGRATION_FILTERS: Record<
  CrmChatProviderKey,
  (items: IntegrationItem[] | null | undefined) => IntegrationItem[]
> = {
  vkontakte: filterVkCrmIntegrations,
  max: filterMaxCrmIntegrations,
  telegram: filterTgCrmIntegrations,
  wazzup: filterWazzupCrmIntegrations,
}

const EMPTY_PROVIDER_INTEGRATIONS: IntegrationItem[] = []

export type UseCrmProviderIntegrationInstancesResult = {
  integrations: IntegrationItem[]
  isLoading: boolean
}

export const useCrmProviderIntegrationInstances = (
  provider: CrmChatProviderKey,
  enabled = true,
): UseCrmProviderIntegrationInstancesResult => {
  const state = useAsync(async () => {
    if (!enabled) {
      return EMPTY_PROVIDER_INTEGRATIONS
    }

    try {
      const res = await integrationsApi.getAll({ provider, usage: 'crm' })
      const raw = res?.data?.data ?? res?.data
      const list = CRM_INTEGRATION_FILTERS[provider](
        Array.isArray(raw) ? raw : [],
      )

      return list.filter((item) => item.status === 'connected')
    } catch {
      return EMPTY_PROVIDER_INTEGRATIONS
    }
  }, [enabled, provider])

  return {
    integrations: state.value ?? EMPTY_PROVIDER_INTEGRATIONS,
    isLoading: Boolean(state.loading),
  }
}
